/**
 * THE SMALL "BY TAPELLIGENCE" LINE EVERY PLAYER PAGE CARRIES.
 *
 * ONE component, rendered inside the player shell itself (GoalFanView's Shell)
 * and on the venue join page, so a screen added later gets it with no extra
 * work. Never drawn on a staff or portal screen.
 *
 * The address is the one super-admin setting, read once per page load and
 * shared by every screen the player walks through.
 */
import { useEffect, useState } from 'react';

const LOGO = '/branding/by-tapelligence.png';
let cached = null;

const websiteUrl = () => {
    if (!cached) {
        cached = fetch('/api/goal-game/public/tapelligence-link')
            .then((r) => (r.ok ? r.json() : { url: '' }))
            .then((d) => String(d.url || ''))
            .catch(() => '');
    }
    return cached;
};

/** @param pad Tailwind bottom-padding class that keeps the line clear of the
 *             game's button bar and the operator bar. */
export const GoalTapelligenceFooter = ({ pad = '' }) => {
    const [url, setUrl] = useState('');

    useEffect(() => {
        let alive = true;
        websiteUrl().then((u) => { if (alive) setUrl(u); });
        return () => { alive = false; };
    }, []);

    const logo = (
        <img src={LOGO} alt="by Tapelligence" loading="lazy" decoding="async"
             className="h-[40px] w-auto object-contain"
             data-testid="tapelligence-footer-logo" />
    );

    return (
        <div className={`w-full flex justify-center py-4 ${pad}`}
             data-testid="tapelligence-footer">
            {url ? (
                <a href={url} target="_blank" rel="noopener noreferrer"
                   aria-label="Tapelligence"
                   data-testid="tapelligence-footer-link"
                   className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center px-3 opacity-90 transition-opacity duration-200 hover:opacity-100">
                    {logo}
                </a>
            ) : (
                <span className="inline-flex min-h-[44px] items-center justify-center px-3 opacity-90">
                    {logo}
                </span>
            )}
        </div>
    );
};

export default GoalTapelligenceFooter;
